import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {addNotification} from '../../redux/actions';
import AppDialog from '../../components/AppDialog';
import {
  Box,
  Button,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  makeStyles,
  Select,
  Typography,
  IconButton,
} from '@material-ui/core';
import api from '../../services/api';
import {Table} from 'antd';
import {Delete as DeleteIcon} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  title: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(2),
  },
  map: {
    height: 215,
    width: '100%',
    position: 'relative',
  },
  TextField: {
    width: '100%',
  },
  formControl: {
    width: 200,
  },
}));

export default function BudgetUsersDialog({budgetId, ...props}) {
  const user = useSelector((state) => state.auth.user);
  const [newUserId, setNewUserId] = useState(0);
  const [users, setUsers] = useState([]);
  const [budgetUsers, setBudgetsUsers] = useState([]);
  const [company_budget_id, setCompanyBudgetId] = useState(0);

  const classes = useStyles();

  const dispatch = useDispatch();

  const columns = [
    {
      title: 'Usuario',
      render: (it) => (
        <Typography>
          {it?.user?.first_name} {it?.user?.last_name}
        </Typography>
      ),
    },
    {
      render: (it) => (
        <IconButton size="small" onClick={() => handleDelete(it.id)}>
          <DeleteIcon color="error" />
        </IconButton>
      ),
    },
  ];

  function _fetchUsers() {
    api.users.find({query: {$client: {company: true}}}).then((it) => {
      setUsers(Object.values(it).filter((it) => it.id !== user?.id));
    });
  }

  function _fetchBudgetUsers(id) {
    if (!company_budget_id) return;
    api.companiesBudgetsUsers.find({query: {company_budget_id: id || company_budget_id}}).then(({data}) => {
      setBudgetsUsers(data);
    });
  }

  function handleAdd() {
    if (!company_budget_id) return;
    api.companiesBudgetsUsers
      .create({company_budget_id, user_id: newUserId})
      .then(() => {
        // _fetchUsers();
        _fetchBudgetUsers();
        dispatch(addNotification('Usuario agregado correctamente', 'success'));
      })
      .catch((e) => {
        dispatch(addNotification(e.message, 'error'));
      });
  }

  function handleDelete(id) {
    api.companiesBudgetsUsers
      .remove(id)
      .then(() => {
        // _fetchUsers();
        _fetchBudgetUsers();
        dispatch(addNotification('Se ha eliminado el usuario', 'success'));
      })
      .catch((e) => {
        dispatch(addNotification(e.message, 'error'));
      });
  }

  useEffect(() => {
    setCompanyBudgetId(budgetId);
  }, [budgetId]);

  useEffect(() => {
    if (props.open) {
      _fetchUsers();
      _fetchBudgetUsers();
    }
    return () => {
      if (!props.open) {
        setBudgetsUsers([]);
        setNewUserId(0);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, company_budget_id]);

  return (
    <AppDialog maxWidth={680} {...props}>
      <DialogTitle className={classes.title}>Administrar usuarios del presupuesto</DialogTitle>
      <DialogContent>
        <Box mb={3} px={1}>
          <Box display="flex" justifyContent="flex-end" alignItems="end">
            <FormControl variant="outlined" className={classes.formControl}>
              <Typography style={{marginBottom: 2}} variant="body2">
                Agregar nuevo usuario
              </Typography>
              <Select
                labelId="user"
                id="user"
                name="user_id"
                margin="dense"
                placeholder="Selecciona un usuario"
                className={classes.TextField}
                value={newUserId}
                onChange={(event) => {
                  setNewUserId(event.target.value);
                }}
              >
                {users.map((it, i) => (
                  <MenuItem value={it.id} key={`item_user_company_budget_${i}`}>
                    {it.first_name} {it.last_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              style={{marginLeft: 5}}
              disabled={!newUserId}
              onClick={() => handleAdd()}
              variant="contained"
              size="small"
              color="primary"
            >
              Agregar
            </Button>
          </Box>
          <Box mt={2}>
            <Table columns={columns} rowKey={(item) => item.id} dataSource={budgetUsers} pagination={false} />
          </Box>
        </Box>
      </DialogContent>
    </AppDialog>
  );
}
